import React from 'react';
import { formatNumber } from '../../utils/formatNumber';
import { getIconByStatus } from './constants';
import './styles.css';

const InsightCard = ({
    icon,
    iconStatus,
    title,
    count,
    percentage,
    infoText,
    onClick,
}) => {
    const isNegative = percentage
        ? parseFloat(percentage.replace(',', '.')) < 0
        : false;

    const formattedCount =
        typeof count === 'number' ? String(formatNumber(count, 0)) : count;

    return (
        <div
            className='animated-card'
            style={{
                width: '230px',
                height: '140px',
                minWidth: '230px',
            }}
            onClick={onClick}
        >
            <section id='card-header'>
                <div className={`icon-box ${iconStatus}`} id='icon-box'>
                    {icon || getIconByStatus(iconStatus)}
                </div>
                <h3 id='title'>{title}</h3>
            </section>

            <div className='card-content' id='card-content'>
                <div className='count-section' id='count-section'>
                    <p id='count'>{formattedCount}</p>
                    {!!percentage && (
                        <div
                            className={`percentage-text ${iconStatus} ${
                                isNegative ? 'negative' : ''
                            }`}
                        >
                            {isNegative ? `${percentage}%` : `+${percentage}%`}
                        </div>
                    )}
                </div>
                <h5 id='info-text'>{infoText}</h5>
            </div>
        </div>
    );
};

export default InsightCard;
